import { Google } from './google'
import { Email } from './email'
import {
  AuthenticationContollerInterface,
  AuthenticationProvider,
  LOCAL_STORAGE_EXPIRY_KEY,
  LOCAL_STORAGE_PROVIDER_KEY,
  LOCAL_STORAGE_TOKEN_KEY,
} from '~/types/auth'

export class AuthenticationController
  implements AuthenticationContollerInterface
{
  getProvider(): AuthenticationProvider | null {
    const provider = localStorage.getItem(LOCAL_STORAGE_PROVIDER_KEY)

    if (provider === '') return null

    return localStorage.getItem(
      LOCAL_STORAGE_PROVIDER_KEY
    ) as AuthenticationProvider
  }

  setProvider(provider: AuthenticationProvider): void {
    localStorage.setItem(LOCAL_STORAGE_PROVIDER_KEY, provider)
  }

  removeProvider(): void {
    localStorage.removeItem(LOCAL_STORAGE_PROVIDER_KEY)
  }

  async getToken(): Promise<string | null> {
    return new Promise((resolve) => {
      if (
        localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) &&
        localStorage.getItem(LOCAL_STORAGE_EXPIRY_KEY)
      ) {
        const now = new Date()
        const expiryString =
          localStorage.getItem(LOCAL_STORAGE_EXPIRY_KEY) ?? now

        if (now < new Date(expiryString)) {
          return resolve(localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY))
        }
      }
      const requestOptions: RequestInit = {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      }
      // @ts-ignore:next-line
      fetch(process.env.serverUrl + '/api/auth/access_token', requestOptions)
        .then((response) => {
          return response.json()
        })
        .then((data: any) => {
          const expiryDate = new Date()
          expiryDate.setSeconds(expiryDate.getSeconds() + data.expiry)
          localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, data.access_token)
          localStorage.setItem(
            LOCAL_STORAGE_EXPIRY_KEY,
            expiryDate.toISOString()
          )
          return resolve(data.access_token)
        })
        .catch(() => {
          return resolve(null)
        })
    })
  }

  isSignedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.getToken().then((token) => {
        return resolve(Boolean(token))
      })
    })
  }

  signInEmail(email: string, password: string): Promise<boolean> {
    return Email.signIn(email, password)
  }

  signInGoogle(credential: google.accounts.id.Credential): Promise<boolean> {
    return Google.signIn(credential)
  }

  signOut = async (): Promise<boolean> => {
    let signedOut = false

    switch (this.getProvider()) {
      case AuthenticationProvider.EMAIL:
        signedOut = await Email.signOut()
        break
      case AuthenticationProvider.GOOGLE:
        signedOut = await Google.signOut()
        break
      default:
        break
    }

    this.removeProvider()
    localStorage.clear()
    if (signedOut) {
      return true
    }
    return false
  }
}
